import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import moment from "moment";
import dustbin from "../../images/dustbin.png";
import AddEntry from "./AddEntry";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { Typography } from "@mui/material";
import EditEntry from "./EditEntry";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import { useDispatch, useSelector } from "react-redux";
import { deleteEntry } from "./httpCalls";
import { BodyContainer, ButtonAdd, Header, TopGrid } from "../styles";
import DateField from "../components/DateField";
import backIcon from "../../images/backIcon.svg";
import add from "../../images/add.svg";
import LedgerHistory from "./LedgerHistory";
import { getLedgerDetail } from "./detailSlice";
import Loader from "../components/Loader";
import LedgerDetailsTable from "./LedgerDetailsTable";

export default function LedgerDetails() {
  const dispatch = useDispatch();
  const hist = useHistory();
  const { type } = useSelector((state) => state.ledger);
  const { detail } = useSelector((state) => state.ledgerDetail);
  const companyCode = localStorage.getItem("companyCode");
  const tokenType = localStorage.getItem("tokenType");

  const ledger = useSelector((state) => state.ledger.selected);
  const [state, setState] = useState({
    loading: false,
    historyModal: false,
    isNew: false,
    editModal: false,
    deleteModal: false,
    record: "",
    filterDate: "",
    selectedSr: "",
    selectedForDelete: "",
  });

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (!type || !ledger) {
      hist.push("/inventory/admin/ledgers");
    } else {
      dispatch(getLedgerDetail({ type, id: ledger._id }));
    }
  }, []);

  const toggle = (name) => {
    setState((pre) => ({ ...pre, [name]: !pre[name] }));
  };

  const handleDelete = (item) => {
    setState((pre) => ({
      ...pre,
      deleteModal: !pre.deleteModal,
      selectedForDelete: item,
    }));
  };
  const deleteRecord = async () => {
    setState((pre) => ({ ...pre, loading: true }));
    await deleteEntry(ledger._id, state.selectedForDelete.srNum, type, hist);
    dispatch(getLedgerDetail({ type, id: ledger._id }));
    setState((pre) => ({ ...pre, deleteModal: false, loading: false }));
  };
  const onSuccess = () => {
    if (!type || !ledger) {
      hist.push("/inventory/admin/ledgers");
    } else {
      dispatch(getLedgerDetail({ type, id: ledger._id }));
    }
  };

  const showFilters = () => {
    // if (ledger && type) {
    if (state.filterDate != "") {
      let filtered = detail.filter(
        (item) =>
          moment.unix(item.date / 1000).format("YYYY-MM-DD") == state.filterDate
      );
      console.log("filtered", filtered);
      return filtered;
    } else {
      console.log("details", detail);
      return detail;
    }
    // } else {
    //   return [];
    // }
  };

  const handleEdit = (item) => {
    setState((pre) => ({ ...pre, record: item, editModal: !pre.editModal }));
  };

  const handleHistory = (srNum) => {
    setState((pre) => ({
      ...pre,
      selectedSr: srNum,
      historyModal: !pre.historyModal,
    }));
  };

  const handleDate = (e) => {
    const { value } = e.target;
    setState((pre) => ({ ...pre, filterDate: value }));
  };

  const handleClear = () => {
    setState((p) => ({ ...p, filterDate: "" }));
  };

  return (
    <Box>
      <Header sx={{ mt: { md: "10px", xs: "40px" } }}>
        <TopGrid container alignItems="center" spacing={1}>
          <Grid item md={3} xs={12} className="ml-n-16 ">
            <DateField
              name="date"
              value={state.filterDate}
              onChange={handleDate}
            />
          </Grid>
          <Grid align="center" item md={6} xs={12}>
            <Typography
              variant="h5"
              sx={{ color: "white", fontSize: { md: "2.125rem", xs: "16px" } }}>
              {`${ledger?.name} ${
                companyCode == "5073"
                  ? (type == "purchase" ? "Pak Rs Balance" : "Aed Balance")
                  : type == "sale"
                  ? "Sale"
                  : "Purchase"
              } Details`}
            </Typography>
          </Grid>

          <Grid item md={1} xs={4} className="ml-n-16 ">
            <Link to={`/inventory/${tokenType == "admin" ? "admin" : "dashboard"}/ledgers`}>
              <ButtonAdd variant="contained" fullWidth>
                Back <img src={backIcon} alt="add" />
              </ButtonAdd>
            </Link>
          </Grid>
          <Grid align="center" item md={1} xs={4}>
            <ButtonAdd
              variant="contained"
              sx={{ width: { md: "100%", xs: "80%" } }}
              onClick={handleClear}>
              Clear
            </ButtonAdd>
          </Grid>
          <Grid align="center" item md={1} xs={4}>
            <ButtonAdd
              variant="contained"
              sx={{ width: { md: "100%", xs: "80%" } }}
              onClick={() => toggle("isNew")}>
              Add <img src={add} alt="add" />
            </ButtonAdd>
          </Grid>
        </TopGrid>
      </Header>

      <LedgerDetailsTable
        showFilters={showFilters}
        state={state}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleHistory={handleHistory}
      />
      <DeleteDialog
        title="Delete Ledger Entry"
        open={state.deleteModal}
        onClose={() => toggle("deleteModal")}
        onClickYes={deleteRecord}
      />

      {state.editModal && (
        <EditEntry
          open={state.editModal}
          record={state.record}
          onClose={() => toggle("editModal")}
          onSuccess={onSuccess}
        />
      )}
      {state.historyModal && (
        <LedgerHistory
          open={state.historyModal}
          id={ledger._id}
          onClose={() => toggle("historyModal")}
          sr={state.selectedSr}
        />
      )}

      {state.isNew && (
        <AddEntry open={state.isNew} onClose={() => toggle("isNew")} />
      )}
    </Box>
  );
}
